import React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { Sidebar } from './Sidebar';

interface BundleFilterProps {
  onClose: () => void;
  bundles: string[];
  selectedBundles: string[];
  onChange: (bundles: string[]) => void;
  runFilter: () => void;
}

export const BundleFilter: React.FC<BundleFilterProps> = ({
  onClose,
  bundles,
  selectedBundles,
  onChange,
  runFilter
}) => {
  const onChangeBundleCheckbox = (bundle: string, val: boolean) => {
    let newBundlesList = [...selectedBundles];
    if (val) {
      newBundlesList.push(bundle);
    } else {
      const delIndex = newBundlesList.findIndex(b => b === bundle);
      newBundlesList.splice(delIndex, 1);
    }
    onChange(newBundlesList);
  };

  return (
    <Sidebar title="Bundle Filter" onClose={onClose} showDoneButton={false}>
      <div style={{ padding: 24 }}>
        <FormGroup>
          {bundles.map(bundle => {
            const isSelected = selectedBundles.includes(bundle);
            return (
              <FormControlLabel
                key={bundle}
                control={<Checkbox />}
                checked={isSelected}
                onChange={(_evt, val) => {
                  onChangeBundleCheckbox(bundle, val);
                }}
                label={bundle}
              />
            );
          })}
        </FormGroup>
      </div>
    </Sidebar>
  );
};
